import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage, injectIntl } from 'react-intl';
import { FormattedHTMLMessage } from '@bibliocommons/react-intl';

import { Generic } from '@bibliocommons/shared-messages';
import { PrimaryButton, TextButton } from '@bibliocommons/deprecated-base-buttons';
import MessagingContainer from 'app/components/Messaging/MessagingContainer';
import FeedbackContactLinks from './FeedbackContactLinks';
import FeedbackForm from './FeedbackForm';

import './FeedbackBox.scss';

const propTypes = {
  categories: ImmutablePropTypes.listOf(PropTypes.string),
  contactLinks: ImmutablePropTypes.mapOf(PropTypes.string, PropTypes.string),
  selectedCategory: PropTypes.string,
  isSubmitting: PropTypes.bool,
  expanded: PropTypes.bool,

  actions: PropTypes.objectOf(PropTypes.func),
  suggestForPurchaseEnabled: PropTypes.bool
};

export class FeedbackBox extends React.PureComponent {
  renderCloseButton(visibleOnMobile) {
    return (
      <TextButton
        type="button"
        className={`close ${visibleOnMobile ? 'visible-xs' : 'hidden-xs'}`}
        aria-label={this.props.intl.formatMessage({ id: 'button_close' })}
        handleClick={this.props.actions.collapseFeedbackBox}
      >
        <span aria-hidden="true">&times;</span>
      </TextButton>
    );
  }

  renderCollapsed() {
    return (
      <div className="feedback-teaser clearfix">
        <div className="col-12 col-xs-12 col-sm-8">
          <h3>
            <FormattedMessage id="feedback_heading" />
          </h3>
          <p>
            <FormattedMessage id="feedback_prompt" />
          </p>
        </div>

        <div className="col-12 col-xs-12 col-sm-4">
          <PrimaryButton
            className="feedback-expand-btn"
            dataKey="submit-feedback-button"
            handleClick={this.props.actions.expandFeedbackBox}
          >
            <FormattedMessage id="feedback_submit_feedback_btn" />
          </PrimaryButton>
        </div>
      </div>
    );
  }

  renderExpanded() {
    return (
      <div className="feedback-expanded clearfix">
        <div className="col-12 col-xs-12 col-sm-7">
          {this.renderCloseButton(true)}
          <h3>
            <FormattedMessage id="feedback_heading" />
          </h3>
          <p>
            <FormattedHTMLMessage id="feedback_review_notice" />
          </p>

          <FeedbackForm
            categories={this.props.categories}
            selectedCategory={this.props.selectedCategory}
            isSubmitting={this.props.isSubmitting}
            actions={this.props.actions}
            suggestForPurchaseEnabled={this.props.suggestForPurchaseEnabled}
          />
        </div>

        <div className="col-12 col-xs-12 col-sm-5">
          {this.renderCloseButton(false)}
          <FeedbackContactLinks contactLinks={this.props.contactLinks} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="cp-deprecated-feedback-box">
        <div className="feedback-wrapper">
          {this.props.expanded ? this.renderExpanded() : this.renderCollapsed()}
          <MessagingContainer id="userFeedback">{messageOptions => <Generic {...messageOptions} />}</MessagingContainer>
        </div>
      </div>
    );
  }
}

FeedbackBox.propTypes = propTypes;

export default injectIntl(FeedbackBox);
